import React from "react";
import "../../../css/Containers/ContainerStyles.css";
import { Colors } from "../../../utils/colors";
import PopupModalContainer, {
  PopupModalContainerWidth,
} from "../PopupModalContainer";
import RectangleButton from "../../Buttons/RectangleButton";
import { ThemeStyle } from "../../../hooks/useTheme";

type ConfirmDeleteModalProps = {
  heading: string;
  subtext?: string;
  deleteButtonText: string;
  hideModal: boolean;
  setIsVisible: (isVisible: boolean) => void;
  deleteOnPress: () => Promise<void> | void;
  buttonLoading?: boolean;
  icon?: React.ReactNode;
  theme?: ThemeStyle;
};

// Used as a replacement to browser window.confirm to confirm an deletion action or cancel
const ConfirmDeleteModal = (props: ConfirmDeleteModalProps) => {
  const {
    heading,
    subtext,
    deleteButtonText,
    hideModal,
    setIsVisible,
    deleteOnPress,
    buttonLoading,
    icon,
    theme,
  } = props;

  return (
    <PopupModalContainer
      headerComp={
        <div className="ColumnNormal" style={{ gap: 4 }}>
          {icon}
          <span style={{ fontSize: 17, fontWeight: "500" }}>{heading}</span>
        </div>
      }
      subHeaderComp={
        <div>
          <span
            style={{
              fontSize: 14,
              color: Colors.GRAY1,
              whiteSpace: "pre-wrap",
            }}
          >
            {subtext}
          </span>
        </div>
      }
      valueComp={
        <div className="RowNormal" style={{ gap: 14 }}>
          <RectangleButton
            buttonLabel="Cancel"
            onPress={() => setIsVisible(false)}
            altTextColor={Colors.BLACK}
            altColor={Colors.GRAY6}
            altPaddingVert={14}
            containerStyles={{
              whiteSpace: "nowrap",
              backgroundColor: Colors.WHITE1,
              border: `1px solid ${Colors.GRAY11}`,
            }}
          />
          <RectangleButton
            buttonLabel={deleteButtonText}
            onPress={async () => {
              await deleteOnPress();
              setIsVisible(false);
            }}
            altTextColor={Colors.WHITE}
            altColor={Colors.RED3}
            altPaddingVert={14}
            loading={buttonLoading}
          />
        </div>
      }
      noExit
      closeModal={() => {}}
      hideModal={hideModal}
      theme={theme}
      modalContentWidth={PopupModalContainerWidth.SMALL}
    />
  );
};

export default ConfirmDeleteModal;
